import { ReactComponent as SearchIcon } from '@Icons/additional/search.svg';

import BaseNameSideItem from '../../../../../enum/BaseNameSideMenuItem.enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const SearchMenuItem: MenuItem = createItem(
  BaseNameSideItem.SEARCH,
  BaseNameSideItem.SEARCH,
  <SearchIcon />
);

export default SearchMenuItem;
